// components
import maPaginator from '@/components/paginator'
import maFilters from '../../components/filters'
import maModal from '@/components/modal'
import maInputText from '@/components/input/modules/text'
import maInputSelect from '@/components/input/modules/select'
import maAdminView from '../adminView'
import maEmpty from '@/components/empty'

// api
import {
  apiGetAdminDamagesReparations,
  apiGetAdminDamagesSurfaceUnits,
  apiPatchAdminDamagesReparations,
  apiGetAdminDamagesDamagetypes,
  apiGetAdminDamagesReparationsTypes
} from '@/services/API/admin'

export default {
  name: 'reparations',
  data: function () {
    return {
      reparation: {
        repTypeCode: null,
        damagesType: null,
        description: null,
        surfaceUnit: null,
        priceCalcForm: null,
        type: null
      },
      surfaceUnitsOptions: null,
      damagestypesOptions: null,
      reparationsTypesOptions: null
    }
  },
  extends: maAdminView,
  components: {
    maPaginator,
    maFilters,
    maModal,
    maInputText,
    maInputSelect,
    maEmpty
  },
  methods: {
    handleSearch: function () {
      apiGetAdminDamagesReparations(this.currentPage, this.filterWarrantyId, this.filterSubwarrantyId)
        .then(reparations => {
          this.table = reparations.results
          this.totalPages = reparations.total_pages || 0
        })
    },
    handleEdit: function (repTypeCode, damagesType, description, surfaceUnit, priceCalcForm, type) {
      this.reparation = { repTypeCode, damagesType, description, surfaceUnit, priceCalcForm, type }
      this.$refs.adminEditModal.showModal = true
      this.getSurfaceUnitsOptions()
      this.getDamagesTypeOptions()
      this.getReparationsTypesOptions()
    },
    triggerModalError: function () {
      this.throwNotification(this.$t('notifications.error.0.title'), this.$t('notifications.error.0.body'), 'KO')
      this.handleCancel()
    },
    getSurfaceUnitsOptions: function () {
      if (!this.surfaceUnitsOptions) {
        apiGetAdminDamagesSurfaceUnits()
          .then(surfaceUnits => {
            this.surfaceUnitsOptions = surfaceUnits
          })
          .catch(err => {
            console.debug('err', err)
            this.triggerModalError()
          })
      }
    },
    getDamagesTypeOptions: function () {
      apiGetAdminDamagesDamagetypes()
        .then(damagestypesOptions => {
          this.damagestypesOptions = damagestypesOptions
        })
        .catch(err => {
          console.debug('err', err)
          this.triggerModalError()
        })
    },
    getReparationsTypesOptions: function () {
      apiGetAdminDamagesReparationsTypes()
        .then(reparationsTypesOptions => {
          this.reparationsTypesOptions = reparationsTypesOptions
        })
        .catch(err => {
          console.debug('err', err)
          this.triggerModalError()
        })
    },
    resetEditValues: function () {
      Object.keys(this.reparation).forEach(rp => { this.reparation[rp] = null })
    },
    handleSave: function () {
      apiPatchAdminDamagesReparations(
        this.reparation.damagesType,
        this.reparation.description,
        this.reparation.repTypeCode,
        this.reparation.surfaceUnit,
        this.reparation.priceCalcForm,
        this.reparation.type
      )
        .then(() => {
          this.handleSearch()
          this.throwNotification(this.$t('notifications.paramChanged.title'), this.$t('notifications.paramChanged.body'), 'OK')
          this.$refs.adminEditModal.showModal = false
        })
        .catch(() => {
          this.throwNotification(this.$t('notifications.error.0.title'), this.$t('notifications.error.0.body'), 'KO')
        })
    }
  },
  mounted: function () {
    this.handleSearch()
  }
}
